import { useQuery } from "@tanstack/react-query";
import { pontoApi, hm } from "@/features/ponto/pontoApi";
import { SelectCadastroRh, type SelectCadastroRhProps } from "./SelectCadastroRh";

/**
 * Jornada do Ponto pelo nome (+ carga semanal). `rotuloNenhum` define o significado do 0:
 * "Sem jornada" no cadastro, "Usar a do cadastro" no espelho.
 */
export function JornadaSelect({ rotuloNenhum = "Sem jornada", placeholder = "Jornada", ...props }: SelectCadastroRhProps) {
  const { data = [] } = useQuery({ queryKey: ["ponto-jornadas"], queryFn: () => pontoApi.jornadas(false), staleTime: 60_000 });
  const opcoes = data.map((j) => ({
    id: j.id,
    rotulo: j.sNome,
    detalhe: j.fCargaSemanalMinutos > 0 ? `${hm(j.fCargaSemanalMinutos)}/sem` : undefined,
    ativo: j.ibAtivo,
  }));
  return <SelectCadastroRh {...props} rotuloNenhum={rotuloNenhum} placeholder={placeholder} opcoes={opcoes} />;
}
